/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2021-01-12 20:31:07
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-01-14 14:57:07
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * @description 获取用户菜单list，用于左侧导航
   * @author YM
   * @date 2019-01-10
   * @returns promise
   */
  getUserMenuList() {
    return request.get(`${BASE_URL}/menu/user_menu`)
  },
  /**
   * @description 获取用户权限list，用于页面按钮相关的控制
   * @author YM
   * @date 2019-01-10
   * @returns promise
   */
  getUserPermissionsList() {
    return request.get(`${BASE_URL}/permissions/user_permissions`)
  },
  /**
   * getOssToken
   * @description 获取上传凭证
   * @author YQ
   * @date 2019-01-19
   * @returns
   */
  getOssToken() {
    return request.post(`${BASE_URL}/upload/get_upload_token`)
  },
  /**
   * editorUploadFile
   * @description 富文本上传文件
   * @author YQ
   * @date 2019-01-31
   * @returns
   */
  editorUploadFile(data, ossUrl) {
    if(ossUrl){
      return request.post(ossUrl, data)
    }else{
      return request.post(`${BASE_URL}/upload/editor`, data)
    }
  },
  /**
   * @description 获取阿里云vod视频上传令牌信息
   * @author YM
   * @date 2019-02-25
   * @returns
   */
  getVodToken(data) {
    return request.post(`${BASE_URL}/upload/get_aliyun_vod_token`,data)
  },
  /**
   * @description 获取阿里云图片地址
   * @author YM
   * @date 2019-02-25
   * @returns
   */
  getPicture(data) {
    return request.post(`${BASE_URL}/upload/get_aliyun_vod_token`,data)
  },
  /**
   * getTaskSign
   * @description 获取签约情况
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getReceipt(data) {
    return request.head(data)
  },

  /**
   * @description 获取服务公司详情-中台
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  getTenantDetail() {
    return request.get(`${BASE_URL}/tenant/detail`)
  },

   /**
   * @description 获取服务公司下的税源地
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  tenantCategoryList() {
    return request.get(`${BASE_URL}/tenant/category_list`)
  },
}